import script from "./RevenueTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueTable.vue?vue&type=script&setup=true&lang=js"

import "./RevenueTable.vue?vue&type=style&index=0&id=74ea18b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ea18b6"]])

export default __exports__